module.exports = __webpack_public_path__ + "img/Germany.5d199876.png";